<template>
  <div>
    <div class="button-wrapper" id="sheet-buttons">
      <button v-for="i in this.papersDetailList.length" :key="i" @click="setProblemNumber(i - 1)">
        {{ i }}
      </button>
    </div>
    <div id="tableTitle">
      <p>{{ $t('SAAI.Result.ResultDetail.name') + ' : ' + title }}</p>
      <p>{{ $t('SAAI.Result.ResultDetail.date') + ' : ' + createdAt }}</p>
    </div>
    <div class="question flex-row flex-even">
      <p class="part-name">{{ question }}</p>
    </div>
    <div
      id="checkboxContainer"
      style="display: flex; justify-content: center; align-items: center; flex-direction: column"
    >
      <p id="checkboxText">
        <b>{{ $t('SAAI.Result.ResultDetail.explanation') }}</b>
      </p>
      <b-form-checkbox-group
        v-model="selectedImportantWords[sheetNumber]"
        :options="importantWordsList[this.sheetNumber]"
        value-field="keyword"
        text-field="keyword"
        @change="handleSelectedWords"
      ></b-form-checkbox-group>
    </div>
    <TabulatorComponent v-model="papersDetail" :options="options" id="ResultDetailTable" />
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { getDetailAnalysisPaperData, getResultImportantKeyword } from '@/api/gradingPaper';

export default {
  name: 'ResultDetailTable',
  components: {
    TabulatorComponent,
  },
  props: {
    selectedResultId: { type: Number, default: 0 },
    createdAt: { type: String, default: '' },
  },
  methods: {
    setProblemNumber(number) {
      this.sheetNumber = number;
      this.papersDetail = this.papersDetailList[number].feedback;
      this.question = this.papersDetailList[number].problemTitle;
    },
    handleSelectedWords() {
      this.$emit('setSelectedWordList', this.selectedImportantWords);
    },
  },
  data() {
    return {
      title: '',
      responseRate: '',
      question: '',
      sheetNumber: 0,
      importantWordsList: [],
      selectedImportantWords: [],
      papersDetailList: [],
      papersDetail: [],
      problemID: 0,
      options: {
        height: '50vh',
        placeholder:
          this.$i18n.locale === 'eng' ? 'Loading data..' : '데이터를 불러오는 중입니다..',
        columns: [
          { title: 'id', field: 'student_id', width: `7%` },
          {
            title: this.$i18n.locale === 'eng' ? 'response' : '응답',
            field: 'content',
            width: `26%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'interval' : '구간',
            field: 'interval_of_student',
            width: `7%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'num' : '단어수',
            field: 'keyword_num',
            width: `7%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'score' : '점수',
            field: 'score',
            formatter: function (cell) {
              return cell.getValue().toFixed(4);
            },
            width: `10%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'missing important keywords' : '빠진 중요어',
            field: 'missing_keywords',
            width: `27%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'feedback' : '피드백 문구',
            field: 'feedback_comment',
            width: `16%`,
          },
        ],
      },
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[1].title = newLocale === 'eng' ? 'response' : '응답';
      this.options.columns[2].title = newLocale === 'eng' ? 'interval' : '구간';
      this.options.columns[3].title = newLocale === 'eng' ? 'num' : '단어수';
      this.options.columns[4].title = newLocale === 'eng' ? 'score' : '점수';
      this.options.columns[5].title =
        newLocale === 'eng' ? 'missing important keywords' : '빠진 중요어';
      this.options.columns[6].title = newLocale === 'eng' ? 'feedback' : '피드백 문구';
    },
  },
  created() {
    getDetailAnalysisPaperData(this.selectedResultId).then((res) => {
      this.title = res.examTitle;
      this.papersDetailList = res.result;
      this.papersDetail = this.papersDetailList[this.sheetNumber].feedback;
      this.question = this.papersDetailList[this.sheetNumber].problemTitle;
      this.problemID = this.papersDetailList[this.sheetNumber].problemID;

      const finalPapersDetailList = [];
      const questions = [];
      this.papersDetailList.forEach((paper) => {
        finalPapersDetailList.push(paper.feedback);
        questions.push(paper.problemTitle);
      });

      this.$emit('setPapersDetailList', finalPapersDetailList);
      this.$emit('setQuestions', questions);
    });
    getResultImportantKeyword(this.selectedResultId).then((res) => {
      const selectedImportantWords = this.selectedImportantWords;
      const importantWordsList = this.importantWordsList;
      let i = 0;
      for (let pages of res.responseAnalys) {
        selectedImportantWords[i] = pages.important_words.split(',');
        importantWordsList[i] = selectedImportantWords[i].map((keyword) => ({ keyword }));
        i++;
      }
      this.$emit('setSelectedWordList', this.selectedImportantWords);
    });
  },
};
</script>

<style lang="scss">
#tableTitle {
  border-left: 1.5px solid $MAIN-COLOR;
  border-right: 1.5px solid $MAIN-COLOR;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-radius: 5px;
  margin-top: 10px;

  P {
    width: 50%;
    text-align: center;
    display: inline-block;
    padding: 10px 0px;
    font-size: 1rem;
    font-weight: bold;
  }
}

#ResultDetailTable {
  box-sizing: border-box;
  max-width: 1200px;
  max-height: none;
  margin: 10px auto 0px auto;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-collapse: collapse;
  table-layout: fixed;
}

.question,
#checkboxContainer {
  margin: 15px 0;
  padding: 10px;
  border: 2px solid $MAIN-COLOR;
  border-left: 1.5px solid $MAIN-COLOR;
  border-right: 1.5px solid $MAIN-COLOR;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-radius: 5px;
}

.part-name {
  margin-right: 10px;
  span {
    font-weight: bold;
  }
}

#sheet-buttons {
  margin: 0px;
}

#checkboxText {
  margin-bottom: 10px;
}
</style>
